import PaymentIcon from '@material-ui/icons/Payment';
import TransactionsList from './TransactionsList';

const Transactions = {
  list: TransactionsList,
  icon: PaymentIcon,
};

export default Transactions
